import { createUpdateMessage } from './update-message';
const updateInfo = createUpdateMessage('Info');
/**
 * Returns a function to add a global info message.
 *
 * Emits a native browser event, keeping this package free of any dependency on redux
 * or the rest of the Famly app.
 *
 * @returns a function to add info messages to the global status bar without any dependencies
 * to the rest of the Famly app
 */
export function useUpdateInfo() {
    return updateInfo;
}
